export const formatPrice = (rowPrice?: number) => {
  if (rowPrice === undefined || rowPrice === null || isNaN(rowPrice)) {
    return "-";
  }

  const formattedPrice = rowPrice.toFixed();
  return `$${formattedPrice}`;
};
